import { ArrowType } from '@ardoq/api-types';
import { IconInfoForSvgImage, IconName } from './types';
import { colors } from '@ardoq/design-tokens';
export const ICON_CLASS_NAME = 'ardoq-icon';
export const ICON_SELECTOR = `.${ICON_CLASS_NAME}`;
export const ASSETS_AND_TEST_CONTAINER_ID = 'assets-and-test-container';

export const CUSTOM_SVG_ICON_CLASS = 'CUSTOM_SVG_ICON_SELECTOR';
export const CUSTOM_SVG_ICON_SELECTOR = `.${CUSTOM_SVG_ICON_CLASS}`;

export const MATERIAL_ICONS_DEFAULT_FONT_SIZE = 24;

// default icon color https://zeroheight.com/0a4741e77/p/77190b-icons/b/75b788/t/93476f
export const DEFAULT_ICON_COLOR = colors.grey500;

// args interpolation: ${iconId}~~${color}~~${fill}~~${stroke}~~${width}~~${height}
export const FALLBACK_IMAGE_ICON_INFO: IconInfoForSvgImage = `${IconName.BROKEN_IMAGE}~~${colors.red700}`;

export const DRAG_BUTTON_CLASS_NAME = 'drag-button';

export const MARKER_PROPS: Record<
  ArrowType,
  { refX: number; markerWidth: number }
> = {
  none: {
    refX: 0.0,
    markerWidth: 0.0,
  },
  circle: {
    refX: 7.0,
    markerWidth: 8.0,
  },
  top: {
    refX: 3.0,
    markerWidth: 4.0,
  },
  diamond: {
    refX: 9.0,
    markerWidth: 10.0,
  },
  diamondFilled: {
    refX: 9.0,
    markerWidth: 10.0,
  },
  bottom: {
    refX: 3.0,
    markerWidth: 4.0,
  },
  both: {
    refX: 3.5,
    markerWidth: 4.0,
  },
  bothFilled: {
    refX: 2.1,
    markerWidth: 3.0,
  },
  bothOutlined: {
    refX: 5.0,
    markerWidth: 6.0,
  },
  circleStart: {
    refX: 0.0,
    markerWidth: 8.0,
  },
  diamondStart: {
    refX: 0.0,
    markerWidth: 10.0,
  },
  diamondFilledStart: {
    refX: 0.0,
    markerWidth: 10.0,
  },
  bothStart: {
    refX: 0.7,
    markerWidth: 4,
  },
  topStart: {
    refX: 0.7,
    markerWidth: 4.0,
  },
  bottomStart: {
    refX: 0.7,
    markerWidth: 4.0,
  },
  bothFilledStart: {
    refX: 2.0,
    markerWidth: 3.0,
  },
  bothOutlinedStart: {
    refX: 0.0,
    markerWidth: 6.0,
  },
  one: {
    refX: 10.0,
    markerWidth: 10.0,
  },
  oneStart: {
    refX: 0.0,
    markerWidth: 10.0,
  },
  oneMandatory: {
    refX: 10.0,
    markerWidth: 10.0,
  },
  oneMandatoryStart: {
    refX: 0.0,
    markerWidth: 10.0,
  },
  many: {
    refX: 12.0,
    markerWidth: 12.0,
  },
  manyStart: {
    refX: 0.0,
    markerWidth: 12,
  },
  oneOrMany: {
    refX: 10.0,
    markerWidth: 12.0,
  },
  oneOrManyStart: {
    refX: 0.0,
    markerWidth: 12.0,
  },
  zeroOrOne: {
    refX: 10.2,
    markerWidth: 10.0,
  },
  zeroOrOneStart: {
    refX: 1.5,
    markerWidth: 10.0,
  },
  zeroOrMany: {
    refX: 16.0,
    markerWidth: 16.0,
  },
  zeroOrManyStart: {
    refX: 0.0,
    markerWidth: 16.0,
  },
  default: {
    refX: 10.0,
    markerWidth: 10.0,
  },
  defaultStart: {
    refX: 0.0,
    markerWidth: 10.0,
  },
};

export const NEGATIVE_COLOR_CSS_VARIABLE = '--negative-color';
